export const styles = (theme) => ({
    title: {
        "& h2": {
            margin: "1.5rem 0 1.5rem 0"
        },
        "& h3": {
            margin: "1.5rem 0",
        },
    },
    userTable: {
        marginTop: "20px",
    },
    buttonMargin: {
        marginTop: -18
    }
});
